// extracted by mini-css-extract-plugin
module.exports = {"menu__list":"Menu_menu__list__j8CVt"};